import { useTranslation } from "react-i18next";

import { LegalDocumentScreen } from "@/components/legal/legal-document-screen";
import { getLegalDocumentWithFallback } from "@/i18n/legal";

export default function TermsOfServiceScreen() {
  const { i18n } = useTranslation();
  return (
    <LegalDocumentScreen
      content={getLegalDocumentWithFallback("terms", i18n.language)}
    />
  );
}
